var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 18.521 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -63.873 54.641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.52 -136.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-56.351-22.223c1.0201 1.2751 2.2719 1.9325 3.7552 1.9717l41.824-0.32527c1.4834-0.0095 3.1055-0.48326 4.8671-1.4204 1.7617-0.93687 3.1572-2.0627 4.1857-3.3767l12.109-15.47c1.0089-1.289 1.5094-2.8712 1.5015-4.7443-0.0079-1.8743-0.52214-3.4489-1.5424-4.7242l-12.242-15.302c-1.0398-1.2997-2.4439-2.4057-4.2142-3.3185-1.7704-0.91264-3.3867-1.3505-4.8499-1.3164l-41.883 0.25222c-1.444 0.01-2.6801 0.67193-3.7084 1.9857-1.0091 1.2892-1.5295 2.8714-1.5603 4.7455l0.18615 36.357c0.0086 1.8245 0.53171 3.3858 1.5716 4.6857z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.177afb4e27f2bd0278dd822e156e3b7e.svg";
export { ForwardRef as ReactComponent };